// extracted by mini-css-extract-plugin
export var attribution = "_a0-4";
export var authorName = "_a0-5";
export var quote = "_a0-3";
export var testimonial = "_a0-2";
export var trustedBy = "_a0-0";
export var trustedByLabel = "_a0-1";